import { useEffect, useRef, useState } from 'react'

// Target timestamp is computed ONCE when the module is first loaded.
// All consumers (UrgencyBanner, FloatingCTA) share the same countdown.
export const COUNTDOWN_MINUTES = 20
const COUNTDOWN_TARGET = Date.now() + COUNTDOWN_MINUTES * 60 * 1000

export function useCountdown() {
  const targetRef = useRef<number>(COUNTDOWN_TARGET)
  const [remaining, setRemaining] = useState(
    Math.max(0, COUNTDOWN_TARGET - Date.now()),
  )

  useEffect(() => {
    const tick = () => {
      const diff = targetRef.current - Date.now()
      setRemaining(diff > 0 ? diff : 0)
    }
    tick()
    const id = setInterval(tick, 1000)
    return () => clearInterval(id)
  }, [])

  const totalSeconds = Math.floor(remaining / 1000)
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60
  const pad = (n: number) => n.toString().padStart(2, '0')

  return {
    minutes,
    seconds,
    formatted: `${pad(minutes)}:${pad(seconds)}`,
    isExpired: remaining === 0,
  }
}
